var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"collCow",staticClass:"collCow"},[_c('div',{staticClass:"formHeader",on:{"click":_vm.formHeaderClicked}},[_c('span',{attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"content-attr"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }